'use client';
import { Alert } from '@/shared/components';
import { useContext, useEffect } from 'react';
import languageContext from '@/context/language';
import { useTranslation } from './i18n/client';
import { useAppStore } from '@/store/app-store';
import { usePathname } from 'next/navigation';

export const CommonErrorAlert = () => {
  const { lang } = useContext(languageContext);
  const { t } = useTranslation(lang, 'common');
  const { commonError, removeCommonError, clearCommonError } = useAppStore();
  const pathname = usePathname();

  useEffect(() => {
    clearCommonError();
  }, [pathname]);

  return (
    <>
      {commonError?.map((error) => {
        return (
          <Alert
            key={error?.languageKey}
            content={
              <>
                <span>{t(error?.languageKey)}</span>
                {error?.arg?.errorId && <span className="ml-4">({error?.arg?.errorId})</span>}
              </>
            }
            open={true}
            type="error"
            className="self-start mt-4"
            onClose={() => removeCommonError(error?.languageKey)}
          />
        );
      })}
    </>
  );
};

export default CommonErrorAlert;
